/* eslint-disable @nx/enforce-module-boundaries */
import {
  Card,
  HStack,
  Heading,
  LinkButton,
  Spinner,
  Stack,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { DashboardPostBox } from 'v4/snippets/dashboard/feed/post-box';
import { PublicProfileContext } from '../context';
import { SearchCardSkeleton } from 'v4/snippets/search/search-card-skeleton';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { getNextPageFromURL } from 'v4/utils/utils';
import { getPublicActivity } from 'v4/store/actions/user-profile.actions';
export const MyProfileActivity = forwardRef(({ ...props }, ref) => {

  ; const {publicProfile } = useContext(PublicProfileContext);
  const [showAll, setShowAll] = useState(true);

  const dispatch=useDispatch();
 const {
   data: activityPosts,
   refetch: refetchActivityPosts,
   hasNextPage: activityPostsHasNextPage,
   fetchNextPage: activityPostsFetchNextPage,
   isFetching: activityPostsIsFetching,
   isLoading: activityPostsIsLoading,
 } = useInfiniteQuery({
   queryKey: ['myActivity',publicProfile?.id],
   queryFn: async ({ pageParam, queryKey }) => {
     const resp = await dispatch(
       getPublicActivity({ page: pageParam, pageSize: 5, userId:queryKey?.[1] })
     );
     return resp?.payload;
   },
   getNextPageParam: (lastPage) => getNextPageFromURL(lastPage?.next),
   refetchOnWindowFocus: false,
   enabled: false,
 });
 useEffect(() => {
  refetchActivityPosts?.();
}, []);

 // Filter out null/undefined posts - can happen if activity API returns 500 or malformed data
 const allPosts = (activityPosts?.pages.flatMap((page) => page?.results) || []).filter(Boolean);
  return (
    <>
      <Stack>
        {activityPostsIsFetching&&allPosts?.length===0 ? (
          <SearchCardSkeleton />
        ) : (
          <>
            {allPosts?.length ? (
              <>
                {/* <HStack p={2}>
              <Stack flex={1}>
                <Heading size="md">Activity</Heading>
              </Stack>
            </HStack> */}
                {showAll ? (
                  <Stack spacing={4}>
                    <InfiniteScroll
                      // dataLength={allPosts?.length ? allPosts?.length: 10}
                      dataLength={allPosts?.length ?? 0}
                      next={activityPostsFetchNextPage}
                      hasMore={!!activityPostsHasNextPage}
                      loader={
                        <HStack p={4} justifyContent="center" w="100%">
                          <Spinner />
                        </HStack>
                      }
                      // endMessage={
                      //   <Text style={{ textAlign: 'center' }} py={3}>
                      //     Yay! You have seen it all
                      //   </Text>
                      // }
                    >
                      {allPosts?.map((p, pIndex) => (
                        <Card key={pIndex} borderTop={pIndex===0?"1px solid #e2e8f0ff":""}>
                          <DashboardPostBox isInFrame={true} post={p} />
                        </Card>
                      ))}
                    </InfiniteScroll>
                  </Stack>
                ) : (
                  <Card>
                    <DashboardPostBox
                      isInFrame={true}
                      post={activityPosts?.pages?.[0]?.results}
                    />
                    {allPosts?.length > 1 ? (
                      <Stack
                        borderTop="1px solid"
                        borderColor="brandGray.500"
                        p={4}
                      >
                        <HStack justifyContent="center">
                          <LinkButton onClick={(e) => setShowAll(true)}>
                            Show more activity
                          </LinkButton>
                        </HStack>
                      </Stack>
                    ) : (
                      ''
                    )}
                  </Card>
                )}
              </>
            ) : (
              <Card p={4}>
                <Stack>
                  <HStack>
                    <Stack flex={1}>
                      <Heading fontSize="16px" fontWeight="400" color="black">Activity</Heading>
                    </Stack>
                  </HStack>
                  <Stack spacing={1}>
                    {/* <Text fontWeight="bold">
                    No activities to show.
                    </Text> */}
                    <Text fontSize="14px">No activities to show.</Text>
                  </Stack>
                </Stack>
              </Card>
            )}
          </>
        )}
      </Stack>
    </>
  );
});
